/**
 * Created by jpilz on 2/13/17.
 */
import ko from 'knockout';
import axios from 'axios';
import $ from 'jquery';

export default class reviewUtil {

    constructor(context) {
        this.name = "reviewUtil";
        this.context = context;
        this.debug = false;

        this.defaultReview = {"id": 0,
        "subId": "string",
        "data": "string",
        "jobid": 0,
        "guid": "string",
        "sort": 0,
        "jdmuserid": 0,
        "role": 0};

        this.log("reviewUtil");
    }

    log(obj)
    {
        if(this.debug)
        {
            console.log("--------------");
            console.log(this.name + ":");
            console.log(obj);
        }
    }

    startReview(jobid) {
        console.log("reviewUtil: startReview");

        let self = this;
        
        //let filter = encodeURI(JSON.stringify({ "where" : { "subId": this.context.subid(), "jobid": jobid}, "order": "sort"}));
        let url = this.context.generateApiUrl('/ReviewApproves/startReview');
        let callData = JSON.stringify({"jobid":jobid, "subparentid":  this.context.subparentid(), "partnerid":  this.context.partnerid()});


        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'POST',
                headers: this.context.apiContentType,
                data: callData
            }).done((data, textResponse, request) => {
                console.log(data);
                resolve(data);
            }).fail((error) =>{
                console.log("startReview Error:");
                reject(error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error getting processing startReview"},"messageModel");
                return;
            });
        });
    }

    stopReview(jobid) {
        console.log("reviewUtil: startReview");

        let self = this;
        
        //let filter = encodeURI(JSON.stringify({ "where" : { "subId": this.context.subid(), "jobid": jobid}, "order": "sort"}));
        let url = this.context.generateApiUrl('/ReviewApproves/stopReview');
        let callData = JSON.stringify({"jobid":jobid, "subparentid":  this.context.subparentid(), "partnerid":  this.context.partnerid()});

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'POST',
                headers: this.context.apiContentType,
                data: callData
            }).done((data, textResponse, request) => {
                console.log(data);
                resolve(data);
            }).fail((error) =>{
                console.log("stopReview Error:");
                reject(error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error getting processing stopReview"},"messageModel");
                return;
            });
        });
    }

    getReviewForJob(jobid) {

        //getPreferences
        console.log("reviewUtil:getReviewForJob jobid: " + jobid + " subparentid: " + this.context.subparentid() + " partnerid:" + this.context.partnerid());

        //let filter = encodeURI(JSON.stringify({ "where" : { "subid": this.context.subid(), "jobid": jobid}, "order": "sort"}));
        let url = this.context.generateApiUrl('/ReviewApproves/getReviewForJob');
        let callData = JSON.stringify({"jobid":jobid, "subparentid":  this.context.subparentid(), "partnerid":  this.context.partnerid()});
        console.log(callData);

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'POST',
                headers: this.context.apiContentType,
                data: callData
            }).done((data, textResponse, request) => {
                console.log(data);
                resolve(data);
            }).fail((error) =>{
                console.log("getReviewForJob Error:");
                reject(error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error getting data for getReviewForJob"},"messageModel");
                return;
            });
        });
    }

    updateReviewForJob(reviewObj) {
        this.log("updateReviewForJob");
        let url = this.context.generateApiUrl('/ReviewApproves/replaceOrCreate');
        let callData = ko.toJSON(reviewObj);

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'POST',
                headers: this.context.apiContentType,
                data: callData
            }).done((data, textResponse, request) => {
                console.log("updateReviewForJob");
                resolve(data);
            }).fail((error) =>{
                console.log("updateReviewForJob Error:");
                reject(error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error processing updateReviewForJob"},"messageModel");
                return;
            });
        });
    }

    deleteReviewForJob(reviewObj) {

        this.log("deleteReviewForJob");
        console.log(reviewObj);
        let url = this.context.generateApiUrl('/ReviewApproves/' + reviewObj.reviewid);
        let callData = ko.toJSON({id: reviewObj.reviewid});

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'DELETE',
                headers: this.context.apiContentType,
                data: callData
            }).done((data, textResponse, request) => {
                this.log("deleteReviewForJob");
                this.log(data);
                resolve(data);
            }).fail((error) =>{
                this.log("deleteReviewForJob Error:");
                reject(error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error deleting deleteReviewForJob"},"messageModel");
                return;
            });
        });
    }

    checkReviewForNextInProcess() {

        console.log('reviewUtil:checkReviewForNextInProcess context.loginStatusObj(): %o', this.context.loginStatusObj());
        

        let filter = encodeURI(JSON.stringify({ "where": {"guid":this.context.paramObj().rid}}));
        let url = this.context.generateApiUrl('/ReviewApproves' + '?filter=' + filter);
        let callData = ko.toJSON({ "where": {"guid":this.context.paramObj().rid}});

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'GET',
                headers: this.context.apiContentType,
                data: callData
            }).done((data, textResponse, request) => {
                console.log("checkReviewForNextInProcess");
                console.log(data);
                
/*
statusid	status
0	none
1	InActive
2	Pending
4	InQueue
6	Active
8	Complete
10	Rejected
*/
                if(data[0].statusid !== 6)
                {
                    this.context.eventManager.notifySubscribers({modalTitle:"Review and Approve:",modalBody:"This review link is not active at this time."},"messageModel");
                    return;
                }
                resolve(data[0]);
            }).fail((error) =>{
                this.log("checkReviewForNextInProcess Error:");
                reject(error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error getting checkReviewForNextInProcess"},"messageModel");
                return;
            });
        });
    }

}




// WEBPACK FOOTER //
// ./src/objects/reviewUtil.js